import React from 'react'
import PropTypes from 'prop-types'
import CustomersItem from "./CustomersItem"

CustomersBody.propTypes = {
  error: PropTypes.string,
  listCustomers: PropTypes.array
}

function CustomersBody(props) {
  const {error, listCustomers} = props

  return (
    <tbody className="CustomersBody">
    {
      !!listCustomers && listCustomers.length > 0 ? listCustomers.map((item, index) => (
        <CustomersItem {...props} key={index} index={index} item={item}/>
      )) : <tr className="NoRecord">
        <td colSpan={12}>Không có bản ghi nào.</td>
      </tr>
    }

    {
      !!error && error.length > 0 && <tr className="NoRecord Error">
        <td colSpan={11}>{error}</td>
      </tr>
    }
    </tbody>
  )
}

export default CustomersBody
